<template>
  <div class="header-title">
    <dv-decoration-8 class="deco-left" />
    <div class="title-center">
      <dv-decoration-11 class="title-bg">
        <span class="title-text">电商销售数据可视化监控中心</span>
      </dv-decoration-11>
    </div>
    <dv-decoration-8 class="deco-right" :reverse="true" />
    <div class="time-display">
      <span class="date-text">{{ currentDate }}</span>
      <span class="time-text">{{ currentTime }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderTitle',
  data() {
    return {
      currentDate: '',
      currentTime: '',
      timer: null
    }
  },
  mounted() {
    this.updateTime()
    this.timer = setInterval(this.updateTime, 1000)
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    updateTime() {
      const now = new Date()
      const y = now.getFullYear()
      const m = String(now.getMonth() + 1).padStart(2, '0')
      const d = String(now.getDate()).padStart(2, '0')
      const h = String(now.getHours()).padStart(2, '0')
      const min = String(now.getMinutes()).padStart(2, '0')
      const s = String(now.getSeconds()).padStart(2, '0')
      /* 星期映射 */
      const weekDays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
      const weekDay = weekDays[now.getDay()]
      this.currentDate = y + '-' + m + '-' + d + ' ' + weekDay
      this.currentTime = h + ':' + min + ':' + s
    }
  }
}
</script>

<style scoped>
.header-title {
  height: 70px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  position: relative;
}

/* 底部渐变分割线 */
.header-title::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, #00D4FF, transparent);
}

.deco-left {
  width: 300px;
  height: 50px;
}

.deco-right {
  width: 300px;
  height: 50px;
}

.title-center {
  flex: 1;
  display: flex;
  justify-content: center;
}

.title-bg {
  width: 600px;
  height: 60px;
}

.title-text {
  font-size: 28px;
  font-weight: bold;
  letter-spacing: 6px;
  background: linear-gradient(180deg, #FFFFFF 0%, #00D4FF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 0 20px rgba(0,212,255,0.5), 0 0 40px rgba(0,212,255,0.2);
}

.time-display {
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.date-text {
  font-size: 12px;
  color: #7B9CC0;
  font-family: 'DIN', 'Courier New', monospace;
  letter-spacing: 1px;
}

.time-text {
  font-size: 18px;
  color: #B0D4F1;
  font-family: 'DIN', 'Courier New', monospace;
  letter-spacing: 2px;
}
</style>
